import { render, staticRenderFns } from "./RsaGestioneOspitiListArchivioComponent.vue?vue&type=template&id=6b5e137b"
import script from "./RsaGestioneOspitiListArchivioComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiListArchivioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports